import type GridCheckboxSelectionColumnOptions from './GridCheckboxSelectionColumnOptions';
import GridColumnOptions from './GridColumnOptions';

interface IGridColumnDefinition<TRowData> {
    /**
     * Common options for all columns
     */
    readonly CommonColumnOptions?: Partial<GridColumnOptions<TRowData>>;

    /**
     * The column options for the grid
     */
    readonly ColumnOptions: GridColumnOptions<TRowData>[]; // Add the missing type argument

    /**
     * The column options for the checkbox selection column
     */
    readonly CheckboxSelectionColumn?: GridCheckboxSelectionColumnOptions<TRowData>;
}

export default class GridColumnDefinition<TRowData> implements IGridColumnDefinition<TRowData> {
    public readonly CommonColumnOptions?: Omit<Partial<GridColumnOptions<TRowData>>, 'columnId'>;
    public readonly ColumnOptions: GridColumnOptions<TRowData>[];
    public readonly CheckboxSelectionColumn?: GridCheckboxSelectionColumnOptions<TRowData>;

    public constructor(columnDef: IGridColumnDefinition<TRowData>) {
        this.CommonColumnOptions = columnDef.CommonColumnOptions;
        this.ColumnOptions = columnDef.ColumnOptions;
        this.CheckboxSelectionColumn = columnDef.CheckboxSelectionColumn;
    }
}
